import React, { Component } from 'react';
import { Dropdown, Carousel, Button, Form } from 'react-bootstrap';
import slider4 from '../Components/Image/slider31.jpg'
import env from '../ENV';
import { connect } from 'react-redux'
import { ChangePassword } from '../store/actions/masterActions';
import authInstance from '../Classes/AuthHandler';
import swal from '@sweetalert/with-react';
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class ForgotPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            userId: authInstance.getUserID()
        }
        //   this.togglebutton = this.togglebutton.bind(this); 
    }
    ChangePassHandler = async () => {
        if (this.state.currentPassword.trim() === '') {
            swal("Please enter your current password", { icon: "error" })
            return false;
        }
        if (this.state.newPassword.trim() === '') {
            swal("Please enter your new password", { icon: "error" })
            return false;
        }
        if (this.state.confirmPassword.trim() === '') {
            swal("Please enter your confirm new password", { icon: "error" })
            return false;
        }
        if (this.state.newPassword.trim().length < 6 || this.state.newPassword.trim().length > 15) {
            swal("New password length must be between 6 to 15", { icon: "error" })
            return false;
        }
        if (this.state.confirmPassword.trim() !== this.state.newPassword.trim()) {
            swal("Confirm new password doesn't match to new password", { icon: "error" })
            return false;
        }
        let data = {
            currentPassword: this.state.currentPassword,
            newPassword: this.state.newPassword,
            confirmPassword: this.state.confirmPassword,
            userId: this.state.userId
        }
        await this.props.ChangePassword(data)
        if (this.props.passStatus) {
            if (this.props.passStatus.status === 200) {
                await this.setState({
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                })
                swal(this.props.passStatus.data.message, { icon: "success" });
            } else {
                let message = this.props.passStatus.data && this.props.passStatus.data.message ? this.props.passStatus.data.message : "Something went wrong, please try again later"
                swal(message, { icon: "error" });
            }
        }
    }

    handleSubmit = async (event) => {
        event.preventDefault();
    }

    changeCurrentPassword = (e) => {
        this.setState({ currentPassword: e.target.value })
    }

    changeNewPassword = (e) => {
        this.setState({ newPassword: e.target.value })
    }

    changeConfirmPassword = (e) => {
        this.setState({ confirmPassword: e.target.value })
    }

    componentDidMount() { }

    render() {

        return (
            <div className="bg-img container-fluid" style={{ padding: "0" }}>
                <Carousel className="container-fluid" controls={false}>
                    <Carousel.Item>
                        <img src={slider4} style={{ width: "100%", height: "100vh", objectFit: "cover" }} />
                        <div className="container-fluid mr-6">
                            {/* <span className="sms-content-slider-header">HIGHLIGHT PROJECTS</span>
                            <span className="sms-content-slider-subheader">SMS Group</span> */}
                            <div className="forgotpass">
                                <h3 style={{ marginBottom: "20px" }}>Change Password</h3>
                                <hr />
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Group size="lg" controlId="email">
                                        <Form.Label className="label"><b>Current Password</b></Form.Label>
                                        <Form.Control
                                            autoFocus
                                            type="Password"
                                            placeholder="Enter Current Password"
                                            required
                                            value={this.state.currentPassword}
                                            onChange={(e) => this.changeCurrentPassword(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group size="lg" controlId="password">
                                        <Form.Label className="label"><b>New Password</b></Form.Label>
                                        <Form.Control
                                            type="Password"
                                            placeholder="Enter New Password"
                                            required
                                            value={this.state.newPassword}
                                            onChange={(e) => this.changeNewPassword(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group size="lg" controlId="password">
                                        <Form.Label className="label"><b>Confirm New Password</b></Form.Label>
                                        <Form.Control
                                            type="Password"
                                            placeholder="Confirm New Password"
                                            required
                                            value={this.state.confirmPassword}
                                            onChange={(e) => this.changeConfirmPassword(e)}
                                        />
                                    </Form.Group>
                                    <button block size="md" type="submit" className="btn btn-block btn-danger rounded-pill" onClick={this.ChangePassHandler}>
                                        Change Password
                                    </button>
                                </Form>
                            </div>
                        </div>
                    </Carousel.Item>


                </Carousel>

            </div>

        )
    }
}

const mapStateToProps = (state) => ({ passStatus: state.masterReducer.passStatus })
export default connect(mapStateToProps, { ChangePassword })(ForgotPassword)